import React, { useState, useEffect } from "react";
import { getStudentIdData } from "../../../lib/studentlessons";
import {
  addData,
  updateData,
  getStudentIdData as geStudentsGrade,
} from "../../../lib/gradeinmonths";
import { getStudentIdWithClassData as getStudentLessons } from "../../../lib/studentlessonsview";
import { ClassForLessonSelect } from "../../ui/myselect";
import { Link } from "react-router-dom";

export default function GlobalGradeInMonth({ studentId, isStudent, ClassId }) {
  const [sClass, setSClass] = useState(ClassId);
  const [lessons, setLessons] = useState();
  const [studentLessons, setStudentLessons] = useState();
  const [grade, setGrade] = useState([]);
  const [showmessage, setShowMessage] = useState(false);
  const [monthList, setMonthList] = useState([
    "September",
    "October",
    "November",
    "December",
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
  ]);

  async function GetParameterData() {
    const lesson = await geStudentsGrade(studentId);
    //console.log("grade", lesson);
    setGrade(lesson);

    const lessonData = await getStudentIdData(studentId);
    setLessons(lessonData);
    //console.log("lessonData", lessonData);

    const stlessons = await getStudentLessons(studentId, sClass);
    setStudentLessons(stlessons);
    //console.log("lesson", stlessons);
  }

  function getGrade(les, month) {
    if (grade.length > 0) {
      const result = grade.filter(
        (item) => item.lesson === les && item.month === month
      );
      //if (les === 12 && month === "October")
      //console.log("result", result[0].grade);
      if (result.length > 0) return result[0].grade;
      else return 0;
    } else return 0;
  }

  function getRecordId(month, les) {
    //console.log("getrecord", les, month);

    //if (slug !== "Add") {
    const result = grade.filter(
      (item) => item.lesson === parseInt(les) && item.month === month
    );
    //console.log("result",result);
    if (result.length > 0) return result[0].id;
    else return 0;
    //}
    //else return 0;
  }

  async function AddGradeData(month, lesson, grade) {
    //console.log("Add", month, lesson, grade);

    await addData({
      studentId: studentId,
      month: month,
      lesson: lesson,
      grade: grade,
    });
  }

  async function UpdateGradeData(recId, grade) {
    //const Id = getRecordId(lesson);
    //console.log("Update", recId, grade);

    await updateData({
      id: recId,
      //studentId: studentId,
      //month: month,
      //lesson: lesson,
      grade: grade,
    });
  }

  function GetGradeColor(lesson, month) {
    const grade = getGrade(lesson, month)
    let color = "#FFFFFF"
    if (grade > 0 && grade < 65) color = '#FF0000'
    if (grade > 64 && grade < 71) color = '#FFA500'
    if (grade > 70 && grade < 81) color = '#FFFF00'
    if (grade > 80 && grade < 91) color = '#32CD32'
    if (grade > 90) color = '#1E90FF'
 
  return { backgroundColor: color }
  }
  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    const formData = new FormData(form);
    const formJson = Object.fromEntries(formData.entries());
    //console.log("form",formJson);
    const formel = [...formData.entries()];
    //console.log("formel",formel);

    Object.entries(formel).forEach((entry) => {
      const [key, value] = entry;
      //console.log("KeyValue", key, value[0], value[1]);
      const monthlesson = value[0].split("-");
      //console.log("Month - grade", monthlesson[0], monthlesson[1]);
      //getRecordId(monthlesson[1]);
      /*
          if (slug === "Add") {
            //AddGradeData(value[0], value[1]);
          }
          else {
            */
      let recId = getRecordId(monthlesson[0], monthlesson[1]);
      //console.log("recId", recId);
      if (recId > 0) UpdateGradeData(recId, value[1]);
      //console.log("Update");
      else AddGradeData(monthlesson[0], monthlesson[1], value[1]);
      //console.log("Add");
      //    }
      //navigate("/student/student-gradeinmonth");
    });

    setShowMessage(true);
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    GetParameterData();
  }, []);

  useEffect(() => {
    GetParameterData();
  }, [sClass]);

  return (
    <div className="col-12">
      <div className="settings-widget profile-details">
        <div className="settings-menu p-2">
          <div className="d-flex pb-1 justify-content-between align-items-center">
            <div className="p-2">
              <h4>Update Grades</h4>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <h4 className="mx-3">Class : </h4> {isStudent ? ClassId : ""}
              {isStudent ? (
                ""
              ) : (
                <ClassForLessonSelect value={sClass} setValue={setSClass} />
              )}
            </div>
            <div className="col-2 form-group ">
              {isStudent ? (
                <Link
                  to="/student911/student-lessonsforgrade"
                  className="btn btn-dark btn-dark-1"
                >
                  List of Courses
                </Link>
              ) : (
                <Link
                  to={`/instructor/instructor-studentlessonforgrade/${studentId}`}
                  className="btn btn-dark btn-dark-1"
                >
                  List of Courses
                </Link>
              )}
            </div>
          </div>
          <div className="checkout-form personal-address add-course-info p-1">
            <div className="row mx-auto">
              {showmessage && (
                <div
                  className="alert alert-success alert-dismissible fade show"
                  role="alert"
                >
                  <strong>Updated!</strong> Your Settings.
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="alert"
                    aria-label="Close"
                    onClick={(e) => setShowMessage(false)}
                  ></button>
                </div>
              )}
              <form method="post" onSubmit={handleSubmit}>
                <div className="col-12">
                  {/* <div className="row">
                    <div className="col-4 form-group">
                      <p className="fs-6 fw-bold">
                        Class : {isStudent ? ClassId : ""}
                      </p>
                      {isStudent ? (
                        ""
                      ) : (
                        <p>
                          <ClassForLessonSelect
                            value={sClass}
                            setValue={setSClass}
                          />
                        </p>
                      )}
                    </div>
                    <div className="col-6"></div>
                    <div className="col-2 form-group ">
                      {isStudent ? (
                        <Link
                          to="/student911/student-lessons"
                          className="btn btn-dark btn-dark-1"
                        >
                          List of Courses
                        </Link>
                      ) : (
                        <Link
                          to={`/instructor/instructor-studentlesson/${studentId}`}
                          className="btn btn-dark btn-dark-1"
                        >
                          List of Courses
                        </Link>
                      )}
                    </div>
                  </div> */}
                  <div className="form-group mt-2">
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th>--</th>
                          {monthList.map(function (month, ix) {
                            return (
                              <>
                                <th key={ix} className="text-center fs-6">
                                  {month.substring(0, 3)}
                                </th>
                              </>
                            );
                          })}
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {studentLessons
                          ? studentLessons.map(function (less) {
                              //monthList.map(function (month, ix) {
                              return (
                                <tr key={less.id}>
                                  <td className="fs-6 fw-bold">
                                    {less.pname}
                                    <br></br>
                                    <span className="fw-normal">
                                      {" "}
                                      {less.lessonName}
                                    </span>
                                  </td>
                                  {monthList.map(function (month, ix) {
                                    const currentGrade = getGrade(
                                      less.id,
                                      month
                                    );
                                    return (
                                      <td key={ix}>
                                        <input
                                          type="number"
                                          value={currentGrade}
                                          name={month + "-" + less.id}
                                          min="0"
                                          max="100"
                                          className="form-control"
                                          placeholder="Enter Grade"
                                          style={GetGradeColor(less.id, month)}
                                          onChange={(e) => {
                                            const newGradeValue =
                                              parseInt(e.target.value, 10) || 0;
                                            const updatedGrade = grade.map(
                                              (item) =>
                                                item.lesson === less.id &&
                                                item.month === month
                                                  ? {
                                                      ...item,
                                                      grade: newGradeValue,
                                                    }
                                                  : item
                                            );
                                            if (
                                              !updatedGrade.find(
                                                (item) =>
                                                  item.lesson === less.id &&
                                                  item.month === month
                                              )
                                            ) {
                                              updatedGrade.push({
                                                studentId,
                                                lesson: less.id,
                                                month,
                                                grade: newGradeValue,
                                              });
                                            }
                                            setGrade(updatedGrade);
                                          }}
                                        />
                                      </td>
                                    );
                                  })}
                                  <td></td>
                                </tr>
                              );
                            })
                          : ""}
                      </tbody>
                    </table>
                  </div>
                  <div className="update-profile d-flex justify-content-between">
                    <button type="submit" className="btn btn-primary">
                      Update Grade
                    </button>
                    {/*
                  <button onClick={() => navigate(-1)} className="btn btn-black btn-sm">
                    Cancel
                  </button>
                      */}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
